import request from '@/util/bpmRequest'

/**
 * 获取列表
 */
export function list(data) {
  return request({
    url: '/task/list',
    method: 'post',
    data
  })
}

/**
 * 获取列表
 */
export function count(data) {
  return request({
    url: '/task/count',
    method: 'post',
    data
  })
}

/**
 * 分页获取列表
 */
export function listPage(data) {
  return request({
    url: '/task/listPage',
    method: 'post',
    data
  })
}

/**
 * 分页获取列表
 */
export function pageHistoryTask(data) {
  return request({
    url: '/task/pageHistoryTask',
    method: 'post',
    data
  })
}

/**
 * 获取流程实例的活动节点
 */
export function getActivityByProcInstId(params) {
  return request({
    url: '/task/getActivityByProcInstId',
    method: 'post',
    params
  })
}
/**
 * 提交任务
 */
export function commit(data) {
  return request({
    url: '/task/commit',
    method: 'post',
    data
  })
}
/**
 * 提交任务
 */
export function reject(data) {
  return request({
    url: '/task/reject',
    method: 'post',
    data
  })
}
/**
 * 获取审批意见列表
 */
export function listTaskApproval(data) {
  return request({
    url: '/task/listTaskApproval',
    method: 'post',
    data
  })
}

/**
 * 保存节点设置
 */
export function saveTaskSet(data) {
  return request({
    url: '/task/saveTaskSet',
    method: 'post',
    data
  })
}
/**
 * 保存节点设置
 */
export function getTaskSet(data) {
  return request({
    url: '/task/getTaskSet',
    method: 'post',
    data
  })
}

/**
 * 修改审批用户
 */
export function changeTaskUser(data,procInstId) {
  return request({
    url: '/task/changeTaskUser',
    headers: procInstId,
    method: 'post',
    data
  })
}

/**
 * 修改审批用户
 */
export function getRunTaskInfo(data) {
  return request({
    url: '/task/getRunTaskInfo',
    method: 'post',
    data
  })
}

/**
 * 加签
 */
export function addSign(data,procInstId) {
  return request({
    url: '/task/addSign',
    headers: procInstId,
    method: 'post',
    data
  })
}




